export default __webpack_public_path__ + "ffd0a115f2d571748d74610f2c772d1d.png";